// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "closeFullscreen-2bMMJ";
var _3 = "closePopup-1Rb5_";
var _4 = "closeIcon-vkhk_";
export { _1 as "__esModule", _2 as "closeFullscreen", _3 as "closePopup", _4 as "closeIcon" }
export default { "__esModule": _1, "closeFullscreen": _2, "closePopup": _3, "closeIcon": _4 }
